import React from 'react';
// Bootstrap imports
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// Component Imports
import PortalSessionsTable from '../../components/it_operations/portal_sessions/PortalSessionsTable';
import PortalSessionsMetrics from '../../components/it_operations/portal_sessions/PortalSessionsMetrics';
// import UserClientList from '../../components/it_operations/UserClientList';

const PortalSessions = () => {
    // const userClientListRef = React.useRef(null);
    // const startScroll= () => userClientListRef.current.scrollIntoView({behavior : "smooth"});
    return (
        <Col sm>
            <Container fluid className="main-content">
                {/* <span onClick={startScroll} className="btn btn-link">Scroll to bottom</span> */}
                <div className="w-100 d-flex justify-content-center">
                    <h3>Portal Sessions</h3>
                </div>
                <Row noGutters className="mb-4">
                    <PortalSessionsTable />
                </Row>
                <Row noGutters className="mb-4">
                    <PortalSessionsMetrics />
                </Row>
                {/* <Row noGutters className="mb-4" ref={userClientListRef} >
                    <UserClientList />
                </Row> */}
            </Container>
        </Col>
    );
}

export default PortalSessions;